export const notificationsService = {
  queryKeys: {
    list: ['notifications'] as const,
  },
  endpoints: {
    list: '/api/v1/notifications',
    readAll: '/api/v1/notifications/read-all',
    stream: '/api/v1/notifications/stream',
  },
}
